// Pricing js
import React, { Component } from 'react';
import webservice from '../services/webservice';
import { Api } from '../common/variables';
import renderHTML from 'react-render-html';
import MetaTags from 'react-meta-tags';
import Loader from '../common/Loader';

// Redux set data
import { connect } from "react-redux";

class Pricing extends Component {
	constructor() {
		super()
		this.state = {
			pageDetailApi: false,
		}
	}

	async componentDidMount() {
		let params = {
			pageSlug : 'pricing',
			lang     : this.props.language
		}

		let getPageDetail = await webservice.httpPost( Api.method.getPageDetail, params );
		if ( getPageDetail.status === 'ok' ) {
			this.setState({
				pageDetailApi    : true,
				pageTitle        : getPageDetail.data.title,
				pageContent      : getPageDetail.data.content,
				metaTitle        : getPageDetail.data.meta_title,
				metaKeywords     : getPageDetail.data.meta_keywords,
				metaDescriptions : getPageDetail.data.meta_descriptions
			})
		} else {
			document.location.href = Api.backEndapiUrl;
		}
	}

	render() {
		return (
			<div className="termsPage">
				{/*For Meta tags Dynamic content*/}
				<MetaTags>
					<title>{ this.state.metaTitle ? this.state.metaTitle : 'Om Valley Liquor - A place for your thirst' }</title>
					<meta name="keywords" content={ this.state.metaKeywords ? this.state.metaKeywords : 'pricing, gharbanau' } />
					<meta
					name="description"
					content={ this.state.metaDescriptions ? this.state.metaDescriptions : 'Om Valley Liquor - A place for your thirst' }
					/>
				</MetaTags>

				{
					( this.state.pageDetailApi ) ?
					<div className="pricingpage">
						{
							( this.state.pageTitle ) ?
							<div className="banner">
								<div className="image_sec bgColor_sec" key='1' >
									<div className="bannercontent">
										<div className="wrapper wrapper_1200">
											<span className="title-small-banner">{ this.state.pageTitle }</span>
										</div>
									</div>
								</div>
							</div>
							: null
						}

						<div className="innerContent">
							<div className="wrapper wrapper_1200">
								{ ( this.state.pageContent ) ? renderHTML( this.state.pageContent ) : null }
							</div>
						</div>
					</div>
					: <Loader />
				}
			</div>
		);
	}
}

const mapStateToProps = state => ({
	...state
});

export default connect( mapStateToProps, null )(Pricing);